import View from '@/components/common/view'
// 大地低职业
import calssType from '../components/companyGroupEmployerDadi/calssType';
import indexDadiM1 from '../components/companyGroupEmployerDadi/indexCCIC_M1';
import indexDadiM2 from '../components/companyGroupEmployerDadi/indexCCIC_M2';
import indexDadiM3 from '../components/companyGroupEmployerDadi/indexCCIC_M3';
import indexDadiM4 from '../components/companyGroupEmployerDadi/indexCCIC_M4';
import indexDadiM5 from '../components/companyGroupEmployerDadi/indexCCIC_M5';

import EmployerEdit from '../components/companyGroupEmployerDadi/Edit';
import EmployerEditBatch from '../components/companyGroupEmployerDadi/EditBatch';
import EmployerFillin from '../components/companyGroupEmployerDadi/Fillin';
import EmployerConfirm from '../components/companyGroupEmployerDadi/Confirm';
export default [
	{
		path:'',
		component:View,
		children:[
			{
				path:'dadiM1',
				component:indexDadiM1
			},
			{
				path:'dadiM2',
				component:indexDadiM2
			},
			{
				path:'dadiM3',
				component:indexDadiM3
			},
			{
				path:'dadiM4',
				component:indexDadiM4
			},
			{
				path:'dadiM5',
				component:indexDadiM5
			},
			{
                path: 'calssType',
                component: calssType
            },
			{
				path:'fillin/:id?',
				component:EmployerFillin
			},
			{
				path:'edit/:id',
				component:EmployerEdit
			},
			{
				path:'edit-batch/:id',
				component:EmployerEditBatch
			},
			{
				path:'confirm/:id?',
				component:EmployerConfirm
			}
		]
	}
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/companyGroupEmployerDadi.js